<template>
  <div key="accountInfo" class="accountInfo">
    <header-item :title-array="titleArray" />
    <common-navbar v-if="$isFlag" />
    <div class="formClass">
      <img
        v-if="$isFlag"
        class="imgclass"
        src="~assets/images/accountCenter/161.png"
        alt=""
      >
      <van-form class="info">
        <van-field
          v-model="userInfo.username"
          class="infoCell"
          style="border-radius:8px 8px 0 0"
          label="雷霆账号:"
          readonly
        />
        <van-field
          v-model="userInfo.passWordText"
          class="infoCell"
          label="登录密码:"
          readonly
        >
          <template #button>
            <p style="color: #616edf; cursor: pointer" @click="passWordDeal">
              {{ userInfo.isSetPwd ? "修改" : "去设置" }}
            </p>
          </template>
        </van-field>
        <!-- 账号安全 -->
        <van-field
          v-model="userInfo.safeWordText"
          class="infoCell"
          label="账号安全:"
          readonly
          style="height: auto; flex-wrap: wrap;"
        >
          <template #button>
            <p style="color: #616edf; cursor: pointer" @click="safeManage">
              设置
            </p>
          </template>
          <template #extra>
            <p class="safe-word" style="width:100%; text-align: left">注：新设备首次账密登录时，需要通过短信校验。</p>
          </template>
        </van-field>
        <!-- 安全级别： -->
        <van-cell title="安全级别：" class="cellColor infoCell">
          <template #default>
            <div v-if="$isFlag" class="gradeClass">
              <span
                :style="userInfo.securityGrade == 0 ? 'color:#ff3d3d' : ''"
              >低</span>
              <span
                :style="userInfo.securityGrade == 1 ? 'color:#ff9e3d' : ''"
              >中</span>
              <span
                :style="userInfo.securityGrade == 2 ? 'color:#40bc40' : ''"
              >高</span>
            </div>
            <div v-else>
              <div class="gradeClass">
                <p
                  :style="
                    userInfo.securityGrade == 0
                      ? 'background:#ff3d3d'
                      : 'background:#d5d7d8'
                  "
                />
                <span
                  :style="
                    userInfo.securityGrade == 0
                      ? 'color:#ff3d3d'
                      : 'color:#d5d7d8'
                  "
                >低</span>
              </div>
              <div class="gradeClass">
                <p
                  :style="
                    userInfo.securityGrade == 1
                      ? 'background:#ff9e3d'
                      : 'background:#d5d7d8'
                  "
                />
                <span
                  :style="
                    userInfo.securityGrade == 1
                      ? 'color:#ff9e3d'
                      : 'color:#d5d7d8'
                  "
                >中</span>
              </div>
              <div class="gradeClass">
                <p
                  :style="
                    userInfo.securityGrade == 2
                      ? 'background:#40bc40'
                      : 'background:#d5d7d8'
                  "
                />
                <span
                  :style="
                    userInfo.securityGrade == 2
                      ? 'color:#40bc40'
                      : 'color:#d5d7d8'
                  "
                >高</span>
              </div>
            </div>
          </template>
        </van-cell>
        <div />
      </van-form>
      <div class="findThree">
        <p class="auth_p">账号认证</p>
        <div class="auth">
          <div class="name">
            <div class="img">
              <img
                :src="
                  require('@/assets/images/accountCenter/light_icon_id@2' +
                    (userInfo.isBindIdentity ? 'x' : '') +
                    '.png')
                "
                alt=""
              >
            </div>
            <img
              v-show="userInfo.isBindIdentity"
              class="name_rz"
              src="~assets/images/accountCenter/renzheng@2x.png"
              alt=""
            >
            <div class="text">
              <p :style="userInfo.isBindIdentity ? 'color:#606DE2' : ''">
                身份认证
              </p>
              <p style="font-size: 0.27rem">
                {{ userInfo.isBindIdentity ? userInfo.realName : "未实名" }}
              </p>
            </div>
            <div class="btnClick">
              <van-button
                round
                size="small"
                plain
                hairline
                :color="userInfo.isBindIdentity ? '#606DE2' : 'red'"
                @click="authClick(userInfo.isBindIdentity)"
              >{{ userInfo.isBindIdentity ? "查看" : "去实名" }}</van-button>
            </div>
          </div>
          <div class="name">
            <div class="img">
              <img
                :src="
                  require('@/assets/images/accountCenter/iphone' +
                    (userInfo.isBindPhone ? '' : '_default') +
                    '@2x.png')
                "
              >
            </div>
            <img
              v-show="userInfo.isBindPhone"
              class="name_rz"
              src="~assets/images/accountCenter/renzheng@2x.png"
              alt=""
            >
            <div class="text">
              <p :style="userInfo.isBindPhone ? 'color:#606DE2' : ''">
                手机认证
              </p>
              <p style="font-size: 0.27rem">
                {{ userInfo.isBindPhone ? userInfo.phone : "未绑定" }}
              </p>
            </div>
            <div class="btnClick">
              <van-button
                round
                size="small"
                plain
                hairline
                :color="userInfo.isBindPhone ? '#606DE2' : 'red'"
                @click="goBind(userInfo.isBindPhone)"
              >{{ userInfo.isBindPhone ? "修改" : "去绑定" }}</van-button>
            </div>
          </div>
        </div>
        <p style="color: #eb8d12; margin: 0.4rem 0 .1rem 0; font-size: 0.26rem">温馨提示：</p>
        <p style="color: #878787;margin: 0.1rem 0; font-size: 0.24rem; line-height: 0.4rem">
          实名认证、手机认证，可以极大提高您账号的安全性，避免因账号被盗引起的巨大损失。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import headerItem from '@/views/accountCenter/common/header'
import commonNavbar from '@/views/accountCenter/common/commonNavbar'
import * as api from '@/api/account-center-manage/accountInfo'

export default {
  name: 'AccountInfo',
  components: {
    headerItem,
    commonNavbar
  },
  data() {
    return {
      username: '',
      userInfo: {},
      checked: false,
      currentIndex: 0,
      ltCaptcha: null,
      titleArray: ['我的账号信息', '首页', '账号管理中心', '我的账号信息']
    }
  },
  created() {},
  mounted() {
    if (this.$isFlag) {
      document.querySelector('.accountInfo').className = ['accountInfo accountInfoH5 accountCommonH5']
    } else {
      document.querySelector('.accountInfo').className = ['accountInfo accountInfoWeb accountCommonWeb']
    }
    this.getUserInfo()
  },
  methods: {
    passWordDeal() {
      this.$router.push(
        '/accountCenter/accountList/editPhoneNum?type=PWD_MODIFY'
      )
    },
    authClick(type) {
      if (type) {
        this.$ssd.track('leiting_accountmanage_realName')
      } else {
        this.$ssd.track('leiting_accountmanage_goRealName')
      }
      this.$router.push('/accountCenter/accountList/identityAuth')
    },
    getUserInfo() {
      api.info().then((res) => {
        if (res && res.status == 0) {
          this.userInfo = res.data
          if (this.userInfo.isSetPwd) {
            this.userInfo.passWordText = '已设置'
          } else {
            this.userInfo.passWordText = '未设置'
          }
          if (this.userInfo.pwdLoginCodeVerify === 1) {
            this.userInfo.safeWordText = '全部游戏均开启'
          } else if (this.userInfo.pwdLoginCodeVerify === 2) {
            this.userInfo.safeWordText = '全部游戏均关闭'
          } else {
            this.userInfo.safeWordText = '部分游戏关闭'
          }
        }
      })
    },
    onSubmitOne() {
      this.currentIndex++
    },
    goBind(type) {
      if (type) {
        this.$router.push('/accountCenter/accountList/phoneAuth')
        return
      }
      this.$router.push('/accountCenter/accountList/bindPhoneNum')
    },
    typeClick(index) {},
    onSubmitTwo() {},
    safeManage() {
      if (this.userInfo.isBindPhone) {
        this.$router.push('/accountCenter/accountList/accountSecurity')
      } else {
        this.$msg('请先绑定手机号')
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
// h5
  .accountInfoH5 {
    font-size: 0.25rem;
    background: #f5f7fa;

    .checkbox {
      margin: 0.3rem 0;
    }
    .info{

      .infoCell{
        height: 1rem;
        align-items: center;
        font-size: .3rem;
        }
      }
    .gradeClass {
      margin-left: 0.15rem;

      span {
        margin-right: 0.3rem;
      }
    }

    .formClass {
      .cellColor {
        border-radius: 0 0 8px 8px;
        ::v-deep .van-cell__title, .van-cell__value {
          flex: none;
          color: #646566
        }

        div {
          display: flex;
          align-items: center;
          margin-right: 0.4rem;

          p {
            width: 1rem;
            background: #D5D6D8;
            height: 0.18rem;
            // margin-right: 0.2rem;
          }
        }
      }

      padding: 0.4rem;

      .imgclass {
        width: 50%;
        display: block;
        margin: 0.3rem auto;
      }

      .findThree {
        .auth_p {
          font-size: 0.26rem;
          margin: 0.24rem 0;
          color: #afafaf;
        }
        .auth {
          .name {
            flex: 1;
            position: relative;
            display: flex;
            border-radius: 8px;
            background: #fff;
            align-items: center;
            justify-content: space-around;
            padding: 2% 0;
            margin-bottom: 0.2rem;
            height: 1.72rem
            .name_rz {
              position: absolute;
              width: 1.1rem;
              height: 1.1rem;
              top: 0;
              right: 0;
            }

            .btnClick {
              flex: 1;

              .van-button {
                width: 1.54rem;
                font-size: .28rem
              }
            }

            .text {
              flex: 1;

              p:nth-child(1) {
                color: #333333;
                font-size: 0.32rem;
              }

              p:nth-child(2) {
                font-size: 0.26rem;
              }
            }

            .img {
              flex: 1;
              display: flex;
              justify-content: center;

              img {
                height: 1rem;
              }
            }
          }

          .bind {
            flex: 1;
          }
        }

        p {
          font-size: 0.4rem;
          margin: 0.32rem 0;
          color: #787878;
        }
      }
      .safe-word {
        width: 100%
        font-size 0.24rem
        color: #878787
        box-sizing: border-box
      }
    }
  }

// web

  .accountInfoWeb {
    border-radius: 10px;
    background: #fff;
    margin-left: 0.2rem;
    font-size: 0.25rem;

    .gradeClass {
      display: flex;
      flex-direction: column;

      span {
        text-align: center;
        font-size: 0.36rem;
      }
    }

    .checkbox {
      margin: 0.3rem 0;
      font-size: 0.28rem;
    }

    .formClass {
      padding: 0.5rem ;
      padding-top: 0.2rem;

      .info {
        width: 90%;

      }

      ::v-deep .van-cell {
        font-size: 0.34rem;
        height: 1.2rem;
        align-items: center;
        color: #787878;
      }

      .cellColor {
        ::v-deep .van-cell__title, .van-cell__value {
          flex: none;
        }

        div {
          display: flex;
          margin-right: 0.8rem;

          p {
            width: 1.94rem;
            height: 0.28rem;
            // margin-right: 0.2rem;
          }
        }
      }
    }

    .findThree {
      .auth_p {
        font-size: 0.47rem;
        margin: 0.6rem 0 .4rem 0;
        color: black;
      }

      padding-left: 0.35rem;

      .auth {
        display: flex;

        .name {
          position: relative;
          flex: 1;
          display: flex;
          border-radius: 8px;
          background: #F8F8F8;
          align-items: center;
          justify-content: space-around;
          margin-right: 0.5rem;
          padding: 2% 0;

          .btnClick {
            flex: 1;
            .van-button {
              width: 1.54rem;
              font-size: .3rem
            }
          }

          .name_rz {
            position: absolute;
            width: 1.3rem;
            height: 1.3rem;
            top: 0;
            right: 0;
          }

          .text {
            flex: 1;
          }

          .img {
            flex: 1;
            display: flex;
            justify-content: center;

            img {
              height: 1.5rem;
            }
          }
        }

        .bind {
          flex: 1;
        }
      }

      p {
        font-size: 0.4rem;
        margin: 0.32rem 0;
        color: #787878;
      }
    }
    .safe-word {
      width: 100%
      padding-left: 2.32rem
      font-size 0.26rem
      line-height 2
      color: #878787
      box-sizing: border-box
    }
  }
</style>
